<template>
  <v-flex xs12>
    <v-card>
      <v-card-title class="pb-0 pt-1 px-4 layout row wrap">
        <v-text-field
          class="min-w max-w"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-btn fab small flat class="close-btn" absolute @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="license.miniLicenses"
        :search="search"
        :loading="license.length === 0"
        :pagination.sync="pagination"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.licenseKey }}</td>
          <td>{{ formatDate(props.item.createdOn) }}</td>
          <td>{{ formatDate(props.item.getsActiveOn) }}</td>
          <td>{{ formatDate(props.item.expiresOn) }}</td>
          <td>{{ props.item.status }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="warning" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['license'],
    data() {
      return {
        search: '',
        headers: [
          {text: this.$lang.header.licenseKey, value: 'licenseKey', align: 'left',},
          {text: this.$lang.header.createdDate, value: 'createdOn', align: 'left',},
          {text: this.$lang.header.activationDate, value: 'getsActiveOn', align: 'left',},
          {text: this.$lang.header.expiryDate, value: 'expiresOn', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
        ],
        pagination: {
          sortBy: 'createdOn', 
          descending: true,
        },
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .close-btn {
    padding: absolute;
    right: 8px;
    top: 8px;
  }
</style>



// WEBPACK FOOTER //
// MiniLicense.vue?2c932e38